import { Box } from '@mui/material';
import { Link } from 'react-router-dom';
import CouponDarkIcon from '../../../components/icons/CouponDarkIcon';

const MyCouponButton = () => {
  return (
    <Box sx={{ padding: '8px 16px' }}>
      <Link to="/my-coupon" style={{ display: 'block', textDecoration: 'none' }}>
        <Box
          sx={{
            position: 'relative',
            overflow: 'hidden',
            minHeight: { xs: 112, sm: 136 },
            px: { xs: 3, sm: 5 },
            py: { xs: 2.25, sm: 3 },
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            gap: 4,
            color: '#005972',
            background:
              'linear-gradient(150deg, #eee 0%, #d4d8d8 5%, #eeefef 20%, #ffffff 28%, #f6f7f7 50%, #d8dcdc 70%, #949a9a 140%)',
            borderRadius: '15px',
            boxShadow: '0 10px 20px rgba(0, 75, 97, 0.16), inset 0 1px 0 rgba(255, 255, 255, 0.88)',
            transition: 'transform 160ms ease, box-shadow 160ms ease',
            '&::after': {
              content: '""',
              position: 'absolute',
              right: 0,
              bottom: 0,
              width: { xs: 60, sm: 100 },
              height: { xs: 60, sm: 100 },
              zIndex: 1,
              background: '#E1000C',
              clipPath: 'polygon(100% 0, 0 100%, 100% 100%)',
              borderBottomRightRadius: '15px',
            },
            '&:hover': {
              boxShadow: '0 14px 24px rgba(0, 75, 97, 0.2), inset 0 1px 0 rgba(255, 255, 255, 0.9)',
            },
          }}
        >
          <CouponDarkIcon
            width="clamp(80px, 20vw, 120px)"
            height="auto"
            aria-hidden="true"
            focusable="false"
            style={{ flexShrink: 0 }}
          />
          <Box
            sx={{
              minWidth: 0,
              textAlign: 'center',
              lineHeight: 1,
              fontWeight: 800,
              letterSpacing: 0,
              mr: { xs: 0, sm: 3 },
            }}
          >
            <Box
              sx={{
                fontSize: { xs: '2.5rem', sm: '4rem' },
                lineHeight: { xs: 0.9, sm: 0.82 },
                whiteSpace: 'nowrap',
              }}
            >
              คูปองของฉัน
            </Box>
            <Box
              sx={{
                mt: { xs: 0.25, sm: 1 },
                fontSize: { xs: '1.85rem', sm: '2.5rem' },
                lineHeight: 0.95,
                whiteSpace: 'nowrap',
              }}
            >
              My Coupon
            </Box>
          </Box>
        </Box>
      </Link>
    </Box>
  );
};

export default MyCouponButton;
